module.exports = __webpack_public_path__ + "media/dashboard/components/layout/sidebarIcons/logo-menuv4-8d9d966d5cbf5e51b702da698e7e26c8.png";